import { openDB } from 'idb';

const DB_NAME = 'daily-fit-db';
const DB_VERSION = 4;

export async function initDB() {
    return openDB(DB_NAME, DB_VERSION, {
        upgrade(db, oldVersion, newVersion, transaction) {
            // Habit definitions
            if (!db.objectStoreNames.contains('habits')) {
                db.createObjectStore('habits', { keyPath: 'id' });
            }

            // Version 4 update: habits will now include integration_id and source_type
            // No structural change to the store itself is required by IndexedDB for adding properties to objects.

            // Habit logs (completions/values)
            if (!db.objectStoreNames.contains('logs')) {
                const store = db.createObjectStore('logs', { keyPath: 'id', autoIncrement: true });
                store.createIndex('by-date', 'date');
                store.createIndex('by-habit', 'habitId');
                store.createIndex('by-habit-date', ['habitId', 'date'], { unique: true });
            }

            // Photo storage
            if (!db.objectStoreNames.contains('photos')) {
                const store = db.createObjectStore('photos', { keyPath: 'id' });
                store.createIndex('by-log', 'logId');
            }

            // Settings
            if (!db.objectStoreNames.contains('settings')) {
                db.createObjectStore('settings', { keyPath: 'key' });
            }
        },
    });
}

export async function getDB() {
    return openDB(DB_NAME, DB_VERSION);
}
